<template>
  <div>
    <ok-cancel-modal
      :title="$t('health.nutritionalPlan.foodsSelector')"
      :ok-button="$t('commons.ok')"
      :cancel-button="$t('commons.cancel')"
      v-on:ok="onOk"
      v-on:cancel="$emit('close')">
      <div
        slot="body">
        <search-input
          ref="foodSearch"
          class="search-input"
          :focus="true"
          v-on:input="onChangeFilter"/>
        <div
          class="margin-top-xl food-list">
          <h3
            class="margin-bottom-l">
            {{ $t('health.nutritionalPlan.foods') }}
          </h3>
          <radio
            v-for="(food, index) in getFilteredFoods.slice(0, maxFoodsToShow)"
            :key="index"
            v-on:change="onVariableSelected(food)"
            :checked="isChecked(food)"
            radio-size="s"
            :id="String(food.food_id)"
            :label="food.food_name"/>
          <div
            v-if="getFilteredFoods.length > maxFoodsToShow"
            class="and-x-more">
            {{ $t('variables.andXMore', {count: foodToShow() })}}
          </div>
        </div>
      </div>
    </ok-cancel-modal>
  </div>
</template>

<script>
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import SearchInput from '@/components/shared/SearchInput';
import Radio from '@/components/shared/forms/Radio';

export default {
  name: 'AddFoodModal',
  components: {
    OkCancelModal,
    SearchInput,
    Radio
  },
  props: {
    food: {
      type: Object,
      default: () => {
      }
    },
    foods: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      foodFilter: '',
      selectedFood: this.food,
      maxFoodsToShow: 50
    };
  },
  computed: {
    getFilteredFoods () {
      if (this.foodFilter !== '') {
        return this.foods.filter(food => {
          return replaceSpecialChars(food.food_name.toUpperCase()).includes(replaceSpecialChars(this.foodFilter.toUpperCase()));
        });
      }
      return this.foods;
    }
  },
  methods: {
    isChecked (food) {
      return this.selectedFood !== undefined &&
      this.selectedFood !== null &&
      this.selectedFood.food_id === food.food_id ? 'checked' : '';
    },
    onVariableSelected (food) {
      this.selectedFood = food;
    },
    onOk () {
      this.$emit('input', this.selectedFood);
      this.$emit('close');
    },
    onChangeFilter (filter) {
      this.foodFilter = filter;
    },
    foodToShow () {
      return this.getFilteredFoods.length - this.maxFoodsToShow;
    }
  }
};

const replaceSpecialChars = (str) => {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
    .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
    .replace(/(^-+|-+$)/g, ''); // Remove extra hyphens from beginning or end of the string
};
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables.scss";

h3 {
  color: $jamaicol;
}

.food-list {
  min-height: calc(100vh / 2);
  max-height: calc(100vh / 2);
  overflow-y: auto;
}

.search-input {
  margin-bottom: $sp-margin;
}

.and-x-more {
  color: $jamaicol;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/nutritionPlan/AddFoodModal.vue